var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppMenu',{key:"menuItems",attrs:{"menu-items":_vm.menuItems}}),_vm._t("default"),_c('ResponseHandler'),_c('AppNotifications'),_c('NotificationList')],2)}
var staticRenderFns = []

export { render, staticRenderFns }